// ==========================
// CONFIG
// ==========================
const FORM_ID_DESKTOP = 'YmWQQ2';
const FORM_ID_MOBILE = 'WVjXNr';
const BLOCK_KEY = 'klaviyo_popup_block_until';
const TEN_DAYS = 10 * 24 * 60 * 60 * 1000;
const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

// ==========================
// CUSTOMER PRIVACY HELPERS
// ==========================
function getCustomerPrivacy() {
  return window.Shopify?.customerPrivacy ?? null;
}

function shouldShowBanner() {
  const cp = getCustomerPrivacy();
  return typeof cp?.shouldShowBanner === 'function' ? cp.shouldShowBanner() === true : false;
}

function marketingAllowed() {
  const cp = getCustomerPrivacy();

  return typeof cp?.currentVisitorConsent === 'function'
    ? cp.currentVisitorConsent()?.marketing === 'yes'
    : false;
}

function analyticsAllowed() {
  const cp = getCustomerPrivacy();

  return typeof cp?.currentVisitorConsent === 'function'
    ? cp.currentVisitorConsent()?.analytics === 'yes'
    : false;
}

// ==========================
// BLOCK KEY HELPERS
// ==========================
function getBlockExpiry() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + BLOCK_KEY + '=([^;]*)'));

  return match ? Number(decodeURIComponent(match[1])) : 0;
}

function writeBlock(expiry) {
  const maxAge = Math.round((expiry - Date.now()) / 1000);
  if (maxAge <= 0) return;
  document.cookie = BLOCK_KEY + '=' + expiry + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
}

function isBlocked() {
  return document.cookie.split(';').some((c) => c.trim().startsWith(BLOCK_KEY + '='));
}

function setBlock(ms) {
  const expiry = Date.now() + ms;
  // Klaviyo fires both 'submit' then 'close' on form submission.
  // Guard against the 'close' event (TEN_DAYS) overwriting the longer 'submit' block (ONE_YEAR).
  const existing = getBlockExpiry();
  if (!existing || expiry > existing) writeBlock(expiry);
}

// ==========================
// KLAVIYO HELPERS
// ==========================
function openKlaviyoForm() {
  const formId = window.innerWidth < 768 ? FORM_ID_MOBILE : FORM_ID_DESKTOP;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
}

// ==========================
// GTAG CONSENT HELPERS
// ==========================
function updateGtagConsent(bypass = false) {
  if (typeof gtag !== 'function') return;
  gtag('consent', 'update', {
    ad_storage: bypass || marketingAllowed() ? 'granted' : 'denied',
    analytics_storage: bypass || analyticsAllowed() ? 'granted' : 'denied',
    ad_user_data: bypass || marketingAllowed() ? 'granted' : 'denied',
    ad_personalization: bypass || marketingAllowed() ? 'granted' : 'denied',
  });
}

// ==========================
// MICROSOFT CLARITY HELPERS
// ==========================
// https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2
function grantClarityConsent(bypass = false) {
  if (typeof window.clarity === 'function') {
    window.clarity('consentv2', {
      ad_Storage: bypass || marketingAllowed() ? 'granted' : 'denied',
      analytics_Storage: bypass || analyticsAllowed() ? 'granted' : 'denied',
    });
  }
}

// ==========================
// KLAVIYO FORM EVENTS
// Fires on visitor interaction with the Klaviyo popup.
// ==========================
if (!window.__klaviyoListenerAttached) {
  window.__klaviyoListenerAttached = true;
  window.addEventListener('klaviyoForms', (e) => {
    const type = e.detail?.type;
    if (type === 'submit') setBlock(ONE_YEAR); // Klaviyo also fires 'close' after submit — setBlock guards against downgrade.
    if (type === 'close') setBlock(TEN_DAYS);
  });
}

// ==========================
// LIVE CONSENT UPDATES
// Fires when the visitor interacts with the Shopify banner.
// ==========================
document.addEventListener('visitorConsentCollected', (event) => {
  updateGtagConsent();
  grantClarityConsent();
  if (event.detail?.marketingAllowed && !isBlocked()) openKlaviyoForm();
});

// ==========================
// INIT FLOW
// Decision tree runs once after the Shopify Customer Privacy API is ready.
// ==========================
function init() {
  if (!window.Shopify?.loadFeatures) return;

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error) return;

    if (shouldShowBanner()) {
      // Returning user with marketing consent — open Klaviyo now.
      if (marketingAllowed() && !isBlocked()) openKlaviyoForm();

      // Update consent state for returning users with prior consent.
      updateGtagConsent();
      grantClarityConsent();
    } else {
      console.log('Non-regulated region..');
      // Non-regulated region — no banner, no consent required.
      if (!isBlocked()) openKlaviyoForm();
      updateGtagConsent(true);
      grantClarityConsent(true);
    }
  });
}

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}
